import React from "react";
import { Crosshair } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Station + GPS inputs shared by household create/edit forms.
export const StationFields = ({ form, setForm, stations, testPrefix = "hh" }) => {
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const locate = () => {
    if (!navigator.geolocation) { toast.error("Location not available on this device"); return; }
    navigator.geolocation.getCurrentPosition(
      (p) => setForm((f) => ({ ...f, lat: p.coords.latitude.toFixed(6), lng: p.coords.longitude.toFixed(6) })),
      () => toast.error("Could not get location"),
    );
  };
  return (
    <div className="space-y-3">
      <div>
        <Label className="text-xs uppercase tracking-wider text-slate-600 font-semibold">Stabex station</Label>
        <select value={form.station_id || ""} onChange={set("station_id")} data-testid={`${testPrefix}-station`}
          className="mt-1 h-10 w-full border border-slate-300 rounded-sm px-3 text-sm bg-white">
          <option value="">Nearest station (from GPS)</option>
          {stations.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
      </div>
      <div className="grid grid-cols-[1fr_1fr_auto] gap-2 items-end">
        <div><Label className="text-xs uppercase tracking-wider text-slate-600 font-semibold">Latitude</Label>
          <Input type="number" step="any" value={form.lat ?? ""} onChange={set("lat")} className="rounded-sm mt-1" data-testid={`${testPrefix}-lat`} /></div>
        <div><Label className="text-xs uppercase tracking-wider text-slate-600 font-semibold">Longitude</Label>
          <Input type="number" step="any" value={form.lng ?? ""} onChange={set("lng")} className="rounded-sm mt-1" data-testid={`${testPrefix}-lng`} /></div>
        <button type="button" onClick={locate} title="Use my location" data-testid={`${testPrefix}-locate`}
          className="h-10 w-10 grid place-items-center border border-slate-300 rounded-sm text-slate-600 hover:bg-slate-50"><Crosshair size={15} /></button>
      </div>
    </div>
  );
};

export const geoPayload = (form) => ({
  station_id: form.station_id || null,
  lat: form.lat === "" || form.lat == null ? null : Number(form.lat),
  lng: form.lng === "" || form.lng == null ? null : Number(form.lng),
});
